// extracted by mini-css-extract-plugin
export default {"loader":"_2v8nhxoC","card":"_3vqdV2BH","noProjects":"_2HpdUawQ"};